import "./Burger.scss";
import { push as Menu } from "react-burger-menu";
import lg from "./img/LOGO.png";
import tw from "./img/Twitter.png";
import is from "./img/Instagram.png";
import fb from "./img/Facebook.png";
const Burger = () => {
  const snsItem = [
    {
      name: "twitter",
      img: tw,
      url: "https://twitter.com/cha_hashi",
    },
    {
      name: "instagram",
      img: is,
      url: "https://www.instagram.com/church.hashimoto/",
    },
    {
      name: "facebook",
      img: fb,
      url: "https://www.facebook.com/profile.php?id=100046501539339",
    },
  ];

  return (
    <Menu>
      <div className="menu-logo">
        <a href="/"><img src={lg} alt="" /></a>
      </div>
      <div className="Burger-sns">
        <ul>
          {snsItem.map((snsItem) => (
            <li>
              <a href={snsItem.url}>
                <img src={snsItem.img}></img>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <a className="menu-item" href="#Video">
        Music Video
      </a>
      <a className="menu-item" href="#Live">
        Live
      </a>
      <a className="menu-item" href="#Disc">
        Disc
      </a>
      <a className="menu-item" href="#Contact">
        Contact
      </a>
      <a className="menu-item" href="https://note.com/cha_hashi/m/mfe4ab271be3b" target="_blank">
        Lyric
      </a>
      <a className="menu-item" href="https://chahashi922.kawaiishop.jp/" target="_blank">
        Store
      </a>
    </Menu>
  );
};

export default Burger;
